import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          height: '100%',
          width: '100%',
        },
        body: {
          height: '100%',
          width: '100%',
          margin: 0,
          padding: 0,
          backgroundColor: '#f5f5f5',
        },
        '#root': {
          height: '100%',
          width: '100%',
          backgroundColor: '#f5f5f5',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          '&:focus': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:focus-visible': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focusVisible': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:active': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:hover': {
            outline: 'none !important',
          },
          '&::after': {
            display: 'none !important',
          },
          '&::before': {
            display: 'none !important',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:focus': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:focus-visible': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&.Mui-focusVisible': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:active': {
            outline: 'none !important',
            boxShadow: 'none !important',
          },
          '&:hover': {
            outline: 'none !important',
          },
          '&::after': {
            display: 'none !important',
          },
          '&::before': {
            display: 'none !important',
          },
        },
      },
    },
  },
});

export default theme; 